"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const getFoodPreferencesIterator_1 = __importDefault(require("../Maker/getFoodPreferencesIterator"));
const getIsBreastFeedingIterator_1 = __importDefault(require("../Maker/getIsBreastFeedingIterator"));
const getCustomAllergiesIterator_1 = __importDefault(require("../Maker/getCustomAllergiesIterator"));
const customers_1 = __importDefault(require("../../MockData/customers"));
class CustomerInitializer extends AbstractInitializer_1.default {
    constructor(cache, customerModel) {
        super("customer_initializer", cache);
        this.initialize = async () => {
            const customersList = (0, customers_1.default)();
            await this.customerModel.updateCustomers(customersList);
            await this.initializeFoodPreferences(customersList);
            await this.initCalorieBudgets(customersList);
        };
        this.initializeFoodPreferences = async (customersList) => {
            const foodPreferencesIterator = (0, getFoodPreferencesIterator_1.default)();
            const isBreastFeedingIterator = (0, getIsBreastFeedingIterator_1.default)();
            const customAllergiesIterator = (0, getCustomAllergiesIterator_1.default)();
            for (const { id: customerId } of customersList) {
                await this.customerModel.setFoodPreferences(customerId, {
                    allergies: [
                        {
                            name: foodPreferencesIterator.next(),
                        },
                        {
                            name: foodPreferencesIterator.next(),
                        },
                        {
                            name: foodPreferencesIterator.next(),
                        },
                    ],
                    isBreastFeeding: isBreastFeedingIterator.next(),
                    customAllergies: customAllergiesIterator.next(),
                });
            }
        };
        this.initCalorieBudgets = async (customerList) => {
            for (const { id: customerId } of customerList) {
                await this.customerModel.setCalorieBudget(customerId, {
                    forNonTrainingDay: {
                        calories: 900,
                        carbohydrates: 90,
                        fats: 20,
                        proteins: 10,
                        fibers: 99,
                    },
                    forTrainingDay: {
                        calories: 1200,
                        carbohydrates: 100,
                        fats: 50,
                        proteins: 70,
                        fibers: 88,
                    },
                });
            }
        };
        this.customerModel = customerModel;
    }
}
exports.default = CustomerInitializer;
//# sourceMappingURL=CustomerInitializer.js.map